import React from 'react';
import { AlertTriangleIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { problemRisks, problemAnswers } from '../data/problem';
import { galleryImages } from '../data/gallery';
export function ProblemSection() {
  return <section className="w-full bg-sage-800 px-5 py-16 sm:px-8 lg:py-28" data-id="element-148" data-mp="2vqhh2ecujw0x">
      <div className="mx-auto max-w-6xl" data-id="element-149" data-mp="2vp6e2gr86sav">
        <SectionHeading tone="dark" size="lg" overline="La parte que nadie cuenta" title={<>
              Parece simple... hasta que las flores{' '}
              <span className="italic text-gold-200" data-id="element-151" data-mp="3jglge9j059m4">
                se rompen, se manchan o pierden su color
              </span>
            </>} subtitle={<>
              Prensar flores de forma bonita y duradera no depende solo de aplastarlas
              entre páginas. Hay{' '}
              <strong className="font-semibold text-cream" data-id="element-152" data-mp="1k49bzq46wy9m">
                técnica, materiales, tiempos y cuidados
              </strong>{' '}
              que hacen toda la diferencia.
            </>} data-id="element-150" data-mp="39hctg0mk0v99" />

        <ul className="mt-14 grid gap-3 sm:grid-cols-2 lg:grid-cols-5" data-id="element-153" data-mp="ocg7azvid2ps">
          {problemRisks.map(risk => <li key={risk.title} className="flex h-full flex-col rounded-2xl border border-sage-700 bg-sage-900/60 p-5" data-id="element-154" data-mp="sbytdyz2fju7">
              <AlertTriangleIcon className="h-4 w-4 text-rose-400" aria-hidden="true" data-id="element-155" data-mp="122thz9zsavit" />
              <h3 className="mt-3 font-sans text-[14px] font-semibold uppercase tracking-[0.08em] text-cream" data-id="element-156" data-mp="174shu9wbfab0">
                {risk.title}
              </h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-sage-200" data-id="element-157" data-mp="1g2cknn9ttenq">
                {risk.body}
              </p>
            </li>)}
        </ul>

        <div className="mt-14 grid items-center gap-8 rounded-4xl bg-cream p-6 sm:p-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-12" data-id="element-158" data-mp="3huh9gpw13vu8">
          <img src="https://cdn.magicpatterns.com/uploads/jx3TsnMQKdi5bY9FboFDx3/MOCK_UP_DECO_FLORES.png" alt="Mockup del ebook Deco Flores — Guía Completa de Prensado y Manualidades Botánicas" className="mx-auto w-full max-w-[400px] drop-shadow-[0_30px_50px_rgba(56,52,44,0.18)]" data-id="element-159" data-mp="p1bp1r4sywqr" />
          <div data-id="element-160" data-mp="ty272k0642et">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-gold-600" data-id="element-161" data-mp="u1q1dldfssul">
              Lo que resuelve la guía
            </p>
            <h3 className="mt-4 font-serif text-[1.9rem] leading-[1.1] text-sage-800 sm:text-[2.3rem]" data-id="element-162" data-mp="12z0d17u62k01">
              La diferencia entre una flor arruinada y una{' '}
              <span className="italic text-terracotta-500" data-id="element-163" data-mp="1cq3cy6bd0sxq">pieza que dura años</span>{' '}
              está en el método
            </h3>
            <ul className="mt-7 space-y-3.5" data-id="element-164" data-mp="1qqe3t9co67iw">
              {problemAnswers.map(answer => <li key={answer} className="flex items-start gap-3" data-id="element-165" data-mp="1lruh36q94rph">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-sage-700" data-id="element-166" data-mp="25btd186b8gt7">
                    <CheckIcon className="h-3 w-3 text-cream" aria-hidden="true" data-id="element-167" data-mp="2aacyz8kwlslk" />
                  </span>
                  <span className="text-[15px] leading-snug text-sage-800" data-id="element-168" data-mp="20cylnhua1jxh">
                    {answer}
                  </span>
                </li>)}
            </ul>
            <p className="mt-7 border-t border-gold-200 pt-5 text-[14px] italic leading-relaxed text-ink-soft" data-id="element-169" data-mp="1mk0mdkepr7on">
              Cada tanda que sale mal son semanas de espera y materiales que ya
              compraste. La guía existe para que eso no pase desde la primera flor.
            </p>
          </div>
        </div>
      </div>
    </section>;
}